<!--临时客商新增  -->
<template>
	<div class="choice-route-content">
		<el-dialog
			title="选择路线"
			v-if="dialogVisible"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:modal-append-to-body="false"
			width="600px"
		>
			<span slot="title" class="flex flex-middle">
				<div class="title">选择路线</div>
				<el-select
					size="small"
					class="ml10"
					clearable
					v-model="routeType"
					placeholder="请选择"
				>
					<el-option label="单人" value="1"></el-option>
					<el-option label="双人" value="2"></el-option>
					<el-option label="Min" value="0"></el-option>
				</el-select>
				<el-input
					v-model.trim="routeName"
					class="w190 ml10"
					size="small"
					placeholder="路线名称"
					clearable
				>
				</el-input>
				<img
					class="icon-s ml10"
					src="@/assets/images/search.png"
					@click="handleSearch"
					alt=""
				/>
			</span>
			<el-table
				border
				height="450"
				ref="multipleTable"
				:data="routeList"
				:header-cell-style="{
					background: 'rgba(200, 204, 215,.6)',
					color: '#333333'
				}"
				:row-key="
					row => {
						return row.routeId;
					}
				"
				@select-all="handleSelectAll"
				@select="handleSelect"
				v-el-table-infinite-scroll="tableLoad"
			>
				<el-table-column
					type="selection"
					width="50"
					:reserve-selection="true"
					align="center"
				>
				</el-table-column>
				<el-table-column prop="routeName" label="路线名称" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="typeShow" label="类型" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="mainUserName" label="主路线员" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="licensePlate" label="车辆" :show-overflow-tooltip="true">
				</el-table-column>
			</el-table>
			<ul class="footer">
				<li>
					<el-button size="small" type="primary" @click="handleSubmit">
						确定
					</el-button>
				</li>
			</ul>
		</el-dialog>
	</div>
</template>
<script>
import { debounce } from '@/utils/debounce'
export default {
	data() {
		return {
			dialogVisible: false,
			routeType: "",
			routeName: "",
			// 路线列表
			routeList: [],
			// 颜色列表
			color_list: [
				"red",
				"orange",
				"green",
				"lightblue",
				"orchid",
				"darkred",
				"darkblue",
				"darkgreen",
				"purple",
				"cadetblue",
				"lightpink",
				"salmon",
				"lightgreen"
			],
			selection: [],
			groupId: '',
			pageNo: 1,
			// 防重复提交
			submitFlag: true
		};
	},
	methods: {
		init(groupId) {
			this.$nextTick(() => {
				this.dialogVisible = true;
				this.submitFlag = true;
				this.groupId = groupId;
				this.routeName = "";
				this.routeType = "";
				this.handleSearch();
				this.selection = [];
			});
		},
		// 点击确定
		handleSubmit() {
			if(this.submitFlag) {
				this.submitFlag = false;
				if(this.selection.length == 0) {
					this.$message.error('请选择路线');
					return
				}
				this.$request
					.post("routeMapAdd", false, {
						groupId: this.groupId,
						routeIds: this.selection.map(obj => obj.routeId)
					})
					.then(res => {
						this.$emit('routeInfoList');
						this.dialogVisible = false;
					})
					.finally(() => {
						this.submitFlag = true;
					});
			}
		},
		handleSelectAll(selection) {
			this.selection = selection;
		},
		handleSelect(selection, row) {
			this.selection = selection;
		},
		// 搜索
		handleSearch() {
			this.pageNo = 1;
			this.getRouteInfoList();
		},
		// 表格滚动加载
		tableLoad: debounce(function () {
			this.pageNo++;
			this.getRouteInfoList('scroll');
		}, 100, true),
		// 获取路线列表
		getRouteInfoList(type) {
			this.$request
				.post("routeMapInfoList", false, {
					routeName: this.routeName,
					routeType: this.routeType,
					groupId: this.groupId,
					pageNo: this.pageNo,
					pageSize: 50
				})
				.then(res => {
					if (type == 'scroll') {
						this.routeList = this.routeList.concat(res.data && res.data.list || []);
					} else {
						for (let index = 0; index < res.data.list.length; index++) {
							const element = res.data.list[index];
							element.color = this.color_list[index];
							element.colorIndex = index;
						}
						this.routeList = res.data.list;
					}
				});
		}
	}
};
</script>
<style lang="scss" scoped>
.icon-s {
	width: 32px;
	height: 32px;
	cursor: pointer;
}
.footer {
	margin-top: 20px;
	display: flex;
	li {
		flex: 1;
		list-style: none;
		text-align: center;
	}
}
.choice-route-content /deep/ .el-dialog__body {
	padding: 0 5px 20px;
}

.el-table {
	// 深度选择器，去除默认的padding
	/deep/ th {
		padding: 0px;
		line-height: 34px;
	}

	/deep/ td {
		padding: 5px;
	}

	/deep/ .warning-row {
		background: #f1f1f5;
	}
	/deep/ th .el-table__cell {
		padding: 0 !important;
	}
}
</style>
